export default "__VITE_ASSET__BuzpJC_S__"